import { mapGetters } from 'vuex';

export default {
    name: 'homeTopActions',
    computed: {
        ...mapGetters('glb', ['glb']),
        actionsItems() {
            const items = [
                {
                    title: this.molang('home.actionItems.buy.title'),
                    description: this.molang('home.actionItems.buy.description'),
                    href: this.glb.appUrl + 'for-sale/',
                    cta: this.molang('home.actionItems.buy.cta'),
                    image: this.glb.cdnUrl + 'images/desktop/home/top-actions-buy.webp',
                },
                {
                    title: this.molang('home.actionItems.sell.title'),
                    description: this.molang('home.actionItems.sell.description'),
                    href: this.glb.appUrl + 'sell/',
                    cta: this.molang('home.actionItems.sell.cta'),
                    image: this.glb.cdnUrl + 'images/desktop/home/top-actions-sell.webp',
                },
                {
                    title: this.molang('home.actionItems.finance.title'),
                    description: this.molang('home.actionItems.finance.description'),
                    href: this.glb.appUrl + 'mortgages/',
                    cta: this.molang('home.actionItems.finance.cta'),
                    image: this.glb.cdnUrl + 'images/desktop/home/top-actions-finance.webp',
                },
            ]
            return items;
        }
    }
};